import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  companyRegistrationInformation: new analytics.Event({
    name: 'Company Registration Information Submitted',
    description: 'Merchant submits company registration information',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['registrationId', 'organizationRegistrationAuthority', 'registered'],
    userAttributes: ['registered'],
  }),
};
